import HiringAnswers from '@/modules/common/hiring/models/APP/HiringAnswers'
import Insured from '@/modules/common/common/models/APP/Insured'
import type PaymentMethods from '@/modules/common/common/models/MID/PaymentMethods'
import { UserRoleEnum, ForWhomEnum } from '@/modules/core/models/enums'

export default class TravelHiringAnswers extends HiringAnswers<Insured> {
  insuranceType: number
  destinationType: number
  sportInsurance: boolean | undefined
  departureDate: Date
  returnDate: Date
  paymentType: PaymentMethods
  cancellationCoverage: boolean = false

  constructor(data: any = {}) {
    super(data)

    this.insuranceType = data.insuranceType
    this.destinationType = data.destinationType
    this.sportInsurance = data.sportInsurance
    this.departureDate = data.departureDate
    this.returnDate = data.returnDate
    this.insureds = data.insureds
    this.holder = data.holder
    this.paymentType = data.paymentType
    this.cancellationCoverage = data.cancellationCoverage
  }

  get forWhom() {
    const holderRole = this.holder.role
    if (holderRole === UserRoleEnum.HOLDER_NOT_INSURED) {
      return ForWhomEnum.NOT_ME
    } else if (this._insureds.length > 1) {
      return ForWhomEnum.ME_MORE
    }

    return ForWhomEnum.ME
  }

  get forWhomPeople() {
    return this._insureds.length
  }

  get insureds(): Insured[] {
    return this._insureds
  }

  set insureds(value: Insured[]) {
    this._insureds = value?.map((i) => new Insured(i)) ?? []
  }

  get holder(): Insured {
    return this._holder
  }

  set holder(value: Insured) {
    this._holder = value
  }

  get currentInsured(): Insured | null {
    return this._currentInsured ?? null
  }

  set currentInsured(value: Insured | null | undefined) {
    this._currentInsured = value ? new Insured(value) : null
  }

  updateAttributes(newAttributes: Partial<TravelHiringAnswers>) {
    Object.assign(this, newAttributes)
  }

  hasBetterAssurance(): boolean {
    return !!this.sportInsurance
  }

  isDocumentNumberAvailable(number: string, riskNumber: number, role: string): boolean {
    if (
      this.holder.riskNumber !== riskNumber &&
      this.holder.addressDetails &&
      this.holder.documentDetails.documentNumber === number
    ) {
      return false
    }

    if (this.holder.documentDetails.documentNumber === number && role !== this.holder.role)
      return false
    return true
  }
}
